
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { academylist, listvehicle, listvehiclewise, vehicledriverattendance } from "../../../services/admin";
import moment from "moment";
import { roleList, vehtriplist, vehroutelist } from "../../../services/master";
import { transportpushcreate } from "../../../services/common";

export default function Alltransportattendance() {
    const [stime, setSTime] = useState("");
    const [sdate, setSDate] = useState("");

    const [dlist, setDList] = useState([]);

    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [tlist, setTList] = useState([]);
    const [tripid, setTripID] = useState("");

    const [rlist, setRList] = useState([]);        // all routes (master)
    const [routeid, setRouteID] = useState("");    // selected route (header)
    const [vehRoutes, setVehRoutes] = useState([]); // routes for selected vehicle
    const [vehTrips, setVehTrips] = useState([]);   // trips for selected vehicle

    const [wlist, setWlist] = useState([]);
    const [wtype, setWType] = useState("");
    const [vlist, setVList] = useState([]);
    const [vehid, setVehID] = useState("");

    useEffect(() => {
        setSDate(moment(new Date()).format("YYYY-MM-DD"));
        roleList().then((res) => {
            if (res.status === true) {
                setWlist(res.data);
            }
        });
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                listall(arr[0]);

                            }
                        }

                    }
                }
            });
        } else {
            listall("");
        }
    }, []);

    const navigate = useNavigate();

    function handleAcademy(e) {

        if (e !== null) {
            setAcaID(e);
            listall(e)
        } else {
            setAcaID("");
            listall("");

        }
    }

    function listall(acaid) {
        setDList([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
            temp.append("academy_id", acaid.value);
        }
        vehtriplist(temp).then((res) => {
            if (res.status === true) {
                setTList(res.data);
            }
        });

        vehroutelist(temp).then((res) => {
            if (res.status === true) {
                setRList(res.data);
            }
        });


        temp.append("status", 1);
        listvehicle(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].vehicle_no + " - " + res.data.details[i].worker_name,
                            // keep the vehicle's configured route/trip ids (comma separated)
                            routeIds: res.data.details[i].vehicle_route,
                            tripIds: res.data.details[i].vehicle_trip,
                        });
                    }
                    setVList(arr);
                }
            }
        })

    }

    function handleVeh(e) {
        setDList([]);
        setRouteID("");
        setTripID("");
        if (e !== null) {
            setVehID(e);
            // scope route/trip dropdowns to the vehicle's configured ids
            const routeIds = String(e.routeIds || "").split(",").map((v) => v.trim()).filter((v) => v !== "");
            const tripIds = String(e.tripIds || "").split(",").map((v) => v.trim()).filter((v) => v !== "");
            setVehRoutes(rlist.filter((r) => routeIds.includes(String(r.id))));
            setVehTrips(tlist.filter((t) => tripIds.includes(String(t.id))));
        } else {
            setVehID("");
            setVehRoutes([]);
            setVehTrips([]);
        }
    }

    const handleTripChange = (studentId, value) => {
        if (wtype == 9) {
        setDList((prevList) =>
            prevList.map((item) =>
                item.id === studentId ? { ...item, trip: value } : item
            )
        );
    } else {
        setDList((prevList) =>
            prevList.map((item) =>
                item.person_id === studentId ? { ...item, trip: value } : item
            )
        );
    }
    };

    const handleRemChange = (studentId, value) => {
        if(wtype == 9){
            setDList((prevList) =>
                prevList.map((item) =>
                    item.id === studentId ? { ...item, remark: value } : item
                )
            );
        }else{
            setDList((prevList) =>
                prevList.map((item) =>
                    item.person_id === studentId ? { ...item, remark: value } : item
                )
            );
        }
       
    };
    const handleAttendanceChange = (studentId, value) => {
        if (wtype == 9) {
            setDList((prevList) =>
                prevList.map((item) =>
                    item.id === studentId ? { ...item, status: value } : item
                )
            );
        } else {
            setDList((prevList) =>
                prevList.map((item) =>
                    item.person_id === studentId ? { ...item, status: value } : item
                )
            );
        }

    };

    // Narrow a student list to the selected trip. Students carry a comma-separated
    // trip_id (a student can belong to more than one trip). Only filters when the
    // rows actually carry trip info, so it stays non-breaking until the backend
    // includes trip_id in the response.
    function filterByTrip(details, role, selectedTrip) {
        if (role != 4 || selectedTrip === "") {
            return details;
        }
        const hasTrip = details.some(
            (s) => s.trip_id !== undefined && s.trip_id !== null && s.trip_id !== ""
        );
        if (!hasTrip) {
            return details;
        }
        return details.filter((s) =>
            String(s.trip_id)
                .split(",")
                .map((x) => x.trim())
                .includes(String(selectedTrip))
        );
    }

    function handlesubmit(e) {
        e.preventDefault();
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }
        if (valid === "") {
            if (sdate !== "") {
                if (stime !== "") {
                    if (wtype !== "") {
                        if (wtype == 9) {
                            const temp = new FormData();
                            if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                temp.append("academy_id", acaid.value);
                            }
                            temp.append("status", 1);

                            listvehicle(temp).then((res) => {
                                if (res.status === true) {
                                    if (res.data.details.length > 0) {
                                        const updatedData = res.data.details.map((student) => ({
                                            ...student,
                                            remark: "",
                                            trip: "",
                                            status: 1,
                                        }));
                                        setDList(updatedData);
                                    }

                                }
                            })
                        } else {
                            if (vehid !== "") {
                                // Students are assigned to specific trips, so the list must
                                // be narrowed to the chosen trip.
                                if (wtype == 4 && tripid === "") {
                                    toast.error("Please Select Trip");
                                    return;
                                }
                                const temp = new FormData();
                                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                    temp.append("academy_id", acaid.value);
                                }
                                temp.append("role", wtype);
                                temp.append("vehicle", vehid.value);
                                if (wtype == 4 && tripid !== "") {
                                    temp.append("trip", tripid);
                                }

                                listvehiclewise(temp).then((res) => {
                                    if (res.status === true) {
                                        if (res.data.details.length > 0) {
                                            const details = filterByTrip(res.data.details, wtype, tripid);
                                            const updatedData = details.map((student) => ({
                                                ...student,
                                                remark: "",
                                                trip: "",
                                                status: 1,
                                            }));
                                            setDList(updatedData);
                                        }

                                    }
                                })
                            } else {
                                toast.error("Please Select Vehicle");
                            }
                        }
                    } else {
                        toast.error("Please Select Role");
                    }


                } else {
                    toast.error("Please Select Attendance Time");
                }
            } else {
                toast.error("Please Select Date");
            }

        } else {
            toast.error(valid);
        }
    }

    function driversubmit(e) {
        e.preventDefault();
        const astatus = dlist.every((item) => item.status !== "");

        // Route + Trip are chosen at header level for students/teachers.
        if (wtype != 9) {
            if (routeid === "") { toast.error("Please Select Route"); return; }
            if (tripid === "") { toast.error("Please Select Trip"); return; }
        } else {
            const isvalid = dlist.every((item) => item.trip !== "");
            if (!isvalid) { toast.error("Please Select Trip"); return; }
        }
        if (!astatus) { toast.error("Please Select Attendance Status"); return; }

        {
            {
                const temp = new FormData();
                temp.append("attendance_date", sdate);
                temp.append("attendance_time", stime);
                temp.append("count", dlist.length);
                if (wtype != 9) {
                    temp.append("route_id", routeid);
                }
                for (let i = 0; i < dlist.length; i++) {
                    temp.append("id_" + [i + 1], dlist[i].id);
                    temp.append("trip_id_" + [i + 1], wtype != 9 ? tripid : dlist[i].trip);
                    temp.append("role_id_" + [i + 1], wtype);
                    temp.append("stu_id_" + [i + 1], dlist[i].person_id);
                    temp.append("attend_status_" + [i + 1], dlist[i].status);
                    if (dlist[i].remark) {
                        temp.append("remarks_" + [i + 1], dlist[i].remark);
                    }
                }
                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                    temp.append("academy_id", acaid.value);
                }
                vehicledriverattendance(temp).then((res) => {
                    if (res.status === true) {
                        setLoading(false);
                        toast.success(res.message);
                        if (spush && wtype != 9 && dlist.length > 0) {
                            const firstItem = dlist[0];
                            const pushData = new FormData();
                            pushData.append("date", sdate);
                            pushData.append("time", stime);
                            pushData.append("role_id", wtype);
                            pushData.append("vehicle_no", firstItem.vehicle_no || "");
                            pushData.append("route_name", firstItem.vehroute_name || "");
                            if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                pushData.append("academy_id", acaid.value);
                            }
                            dlist.forEach((item) => {
                                pushData.append("student_ids[]", item.person_id);
                                pushData.append("student_names[]", item.person_name || "");
                                pushData.append("student_statuses[]", item.status);
                            });
                            transportpushcreate(pushData).then((pres) => {
                                if (pres && pres.status === true) {
                                    toast.success("Push notifications sent");
                                }
                            });
                        }
                        navigate("/transport/driverattendance");
                    } else {
                        setLoading(false);
                        toast.error(res.message);
                    }
                });
            }
        }


    }
    const [loading, setLoading] = useState(false);
    const [spush, setSpush] = useState(true);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Add Driver Attendance</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Transport</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Add Driver Attendance
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading &&
                <div className="content-body">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Add Attendance</h2>{" "}
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div>
                                        <div className="row">
                                            {localStorage.getItem("Role") === "1" && (
                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Select Academy{" "}
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <Select
                                                            className="default-select"
                                                            placeholder="Select Academy"
                                                            value={acaid}
                                                            options={alist}
                                                            onChange={handleAcademy}
                                                            isSearchable={true}
                                                            isClearable
                                                            hidden
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Date<span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={sdate}
                                                        onChange={(e) => { setSDate(e.target.value); setDList([]); }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Attendance Time
                                                        <span className="text-danger"> *</span>
                                                    </label>
                                                    <select
                                                        onChange={(e) => { setSTime(e.target.value); setDList([]); }}
                                                        value={stime}
                                                        className="default-select form-control wide"
                                                    >
                                                        <option value="" disabled>
                                                            Select Attendance Time
                                                        </option>
                                                        <option value="Morning">Morning</option>
                                                        <option value="Evening">Evening</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Role
                                                        <span className="text-danger"> *</span>
                                                    </label>
                                                    <select
                                                        className="default-select form-control wide"
                                                        onChange={(e) => { setWType(e.target.value); setDList([]); setVehID(""); }}
                                                        value={wtype}
                                                    >
                                                        <option value="" disabled>
                                                            Select Role
                                                        </option>

                                                        {wlist
                                                            .filter(item => [4, 5, 9].includes(item.id))
                                                            .map(item => (
                                                                <option value={item.id} key={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}

                                                    </select>
                                                </div>
                                            </div>
                                            {wtype != 9 && wtype !== "" ? (
                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Vehicle
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <Select
                                                            className="default-select"
                                                            placeholder="Select Vehicle"
                                                            value={vehid}
                                                            options={vlist}
                                                            onChange={handleVeh}
                                                            isSearchable={true}
                                                            isClearable
                                                            hidden
                                                        />
                                                    </div>
                                                </div>
                                            ) : <div className="col-xl-4 col-sm-6"></div>}

                                            {wtype != 9 && wtype !== "" && (
                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Route<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="default-select form-control wide"
                                                            value={routeid}
                                                            onChange={(e) => setRouteID(e.target.value)}
                                                        >
                                                            <option value="" disabled>Select Route</option>
                                                            {vehRoutes.map((r) => (
                                                                <option value={r.id} key={r.id}>{r.vehroute_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            {wtype != 9 && wtype !== "" && (
                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Trip<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="default-select form-control wide"
                                                            value={tripid}
                                                            onChange={(e) => setTripID(e.target.value)}
                                                        >
                                                            <option value="" disabled>Select Trip</option>
                                                            {vehTrips.map((t) => (
                                                                <option value={t.id} key={t.id}>{t.vehtrip_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-xl-4 col-sm-6">
                                                <div className="text-right mt-4 mb-4">
                                                    <a
                                                        className="btn btn-success"
                                                        onClick={handlesubmit}
                                                    >
                                                        Preview
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-body">
                                {wtype == 4 && dlist.length > 0 && (
                                    <div className="mb-3">
                                        <input type="checkbox" className="styled-checkbox" id="pushcheckbox" checked={spush} onChange={(e) => setSpush(e.target.checked)} /> Send Push Notification
                                    </div>
                                )}
                                {wtype != 9 &&
                                    <div className="table-responsive tasks">
                                        <table className="table card-table table-vcenter text-nowrap mb-0  border">
                                            <thead>
                                                <tr>
                                                    <th className="wd-lg-20p text-center">Name</th>
                                                    <th className="wd-lg-20p text-center">Vehicle</th>
                                                    <th className="wd-lg-20p text-center">Route</th>
                                                    <th className="wd-lg-20p text-center">Attendance</th>
                                                    <th className="wd-lg-20p text-center">Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dlist.map((student) => (
                                                    <tr key={student.person_id}>
                                                        <td className="text-center">
                                                            {student.person_name} {student.class_name ? " - " + student.class_name : ""} {student.section_name ? " - " + student.section_name : ""}
                                                        </td>
                                                        <td className="text-center">
                                                            {student.vehicle_no} - {student.worker_name}
                                                        </td>
                                                        <td className="text-center">
                                                            {student.vehroute_name}
                                                        </td>
                                                        <td className="text-center">
                                                            <select
                                                                className="default-select form-control wide"
                                                                onChange={(e) =>
                                                                    handleAttendanceChange(
                                                                        student.person_id,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                value={student.status}
                                                            >
                                                                <option value="" disabled>
                                                                    Select Attendance
                                                                </option>
                                                                <option value={1}>Present</option>
                                                                <option value={0}>Absent</option>
                                                            </select>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="mb-6">
                                                                <input
                                                                    placeholder="Enter Remark"
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleRemChange(
                                                                            student.person_id,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    value={student.remark}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                {wtype == 9 &&
                                    <div className="table-responsive-sm tasks">
                                        <table className="table table-bordered table card-table table-vcenter text-nowrap mb-0  border">
                                            <thead className="headcolor">
                                                <tr>
                                                    <th className="wd-lg-20p text-center">Driver Name</th>
                                                    <th className="wd-lg-20p text-center">Route</th>
                                                    <th className="wd-lg-20p text-center">Trip</th>
                                                    <th className="wd-lg-20p text-center">Attendance</th>
                                                    <th className="wd-lg-20p text-center">Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dlist.map((student) => (
                                                    <tr key={student.id}>
                                                        <td className="text-center">
                                                            {student.vehicle_no} - {student.worker_name}
                                                        </td>
                                                        <td className="text-center">
                                                            {student.vehroute_name}
                                                        </td>
                                                        <td className="text-center">
                                                            <select
                                                                className="default-select form-control wide"
                                                                onChange={(e) =>
                                                                    handleTripChange(
                                                                        student.id,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                value={student.trip}
                                                            >
                                                                <option value="" disabled>
                                                                    Select Trip
                                                                </option>
                                                                {tlist.map((trip) => (
                                                                    <option value={trip.id} key={trip.id}>{trip.vehtrip_name}</option>
                                                                ))
                                                                }
                                                            </select>
                                                        </td>
                                                        <td className="text-center">
                                                            <select
                                                                className="default-select form-control wide"
                                                                onChange={(e) =>
                                                                    handleAttendanceChange(
                                                                        student.id,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                value={student.status}
                                                            >
                                                                <option value="" disabled>
                                                                    Select Attendance
                                                                </option>
                                                                <option value={1}>Present</option>
                                                                <option value={0}>Absent</option>
                                                            </select>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="mb-6">
                                                                <input
                                                                    placeholder="Enter Remark"
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleRemChange(
                                                                            student.id,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    value={student.remark}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }

                                <div className="text-end mt-4 mb-4 me-4">
                                    <button className="btn btn-success" onClick={driversubmit}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            }

        </div>
    );
}
